import { render } from "./property-marketnew.vue?vue&type=template&id=1852c23c"
import script from "./property-marketnew.js?vue&type=script&lang=js"
export * from "./property-marketnew.js?vue&type=script&lang=js"

import "./property-marketnew.vue?vue&type=style&index=0&id=1852c23c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__